import { createPlacementComponent } from '@post-office/placement-common/utils/create-placement-component';

import { useDisableChoreographer, useInitialData } from '@post-office/placement-contexts/hooks';

import { MessageRenderer } from '../__generated__/client/render';

import { PLACEMENT_ID } from '../__generated__/common';

import { withTrelloBoardScreenIntlProvider } from '../__generated__/intl-provider';

import { type TrelloBoardScreenInitialData } from '../api/types';

import { type Placement as TrelloBoardScreenPlacement } from '../contracts/Placement';

import type { Fetcher } from '@atlassian/post-office-placement-data/types';

import { type OnPerformanceTrackingEvent } from '@post-office/placement-contexts/create-placement-component/hooks/usePerformanceTracking/types';

import {
	type ContextWithRoute,
	type ErrorBoundaryAdditionalAnalyticsFacade,
	type FallbackRenderFacade,
} from '@post-office/placement-contexts/create-placement-component/types';

import { type ComponentType } from 'react';

import { type ErrorBoundaryPropsWithRender } from 'react-error-boundary';

export const TrelloBoardScreenPlacementComponent: ComponentType<
	Partial<ErrorBoundaryPropsWithRender> & {
		context: ContextWithRoute;
		initialData: Promise<Response | undefined> | undefined;
		fetch?: Fetcher;
		onEvent?: OnPerformanceTrackingEvent;
	} & TrelloBoardScreenPlacement &
		ErrorBoundaryAdditionalAnalyticsFacade &
		FallbackRenderFacade & {
			messages?: {
				[x: string]: string;
			};
		}
> = withTrelloBoardScreenIntlProvider(
	createPlacementComponent<TrelloBoardScreenPlacement>(
		PLACEMENT_ID,
		({ initialData, children }) => {
			const { data, error, isLoading } = useInitialData<TrelloBoardScreenInitialData>(initialData);
			// Disabling choreographer, as it hides placements even if there are no other placements on the page...
			useDisableChoreographer();
			if (isLoading || error || !data?.messages?.[0]) {
				return <></>;
			}
			const message = data?.messages?.[0];
			return (
				<MessageRenderer {...message}>
					{({
						Heading,
						Body,
						messageClicked,
						messageDismissed,
					}: {
						Heading: () => JSX.Element;
						Body: () => JSX.Element;
						messageClicked: () => void;
						messageDismissed: () => void;
					}) => children({ Heading, Body, messageClicked, messageDismissed })}
				</MessageRenderer>
			);
		},
	),
);

export default TrelloBoardScreenPlacementComponent;
